"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPrt = exports.isStaging = exports.jump = exports.stringify = void 0;
var qs_1 = __importDefault(require("qs"));
// @ts-ignore: third party
var ks_bridge_1 = __importDefault(require("@ks/ks-bridge"));
var device_1 = require("./device");
function stringify(query, path) {
    if (query === void 0) { query = {}; }
    if (path === void 0) { path = ''; }
    var addQueryPrefix = path.indexOf('?') === -1;
    return qs_1.default.stringify(query, { addQueryPrefix: addQueryPrefix });
}
exports.stringify = stringify;
function jump(url, type, ext) {
    if (type === void 0) { type = 'back'; }
    if (ext === void 0) { ext = {}; }
    if (url) {
        if (url.indexOf('kwai://') === 0) {
            location.href = url;
        }
        else {
            if (device_1.isInKwai) {
                ks_bridge_1.default.loadUrlOnNewPage({
                    url: url,
                    type: type,
                });
            }
            else {
                if (ext.newTab) {
                    window.open(url);
                }
                else {
                    location.href = url;
                }
            }
        }
    }
}
exports.jump = jump;
function isStaging() {
    return /staging/.test(window.location.origin);
}
exports.isStaging = isStaging;
function isPrt() {
    return location.host === 'local-life-preonline.test.gifshow.com';
}
exports.isPrt = isPrt;
